import { useEffect } from 'react';
import EcoSection from 'eco-design/base/eco-section';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.Animation1');
    const { t: t1 } = useLang('theProduct.Animation1.screen1');
    const { t: t2 } = useLang('theProduct.Animation1.screen2');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const mask1 = document.querySelector(`.screen1-mask`) as HTMLElement;
            const screen1 = document.querySelector(`.screen-1`) as HTMLElement;
            const screen2 = document.querySelector(`.screen-2`) as HTMLElement;
            const ani = AniContainer.create({
                triggerElement: `.${styles.comp}`,
                triggerHook: 0,
                offset: 0,
                duration: '300%',
                onEnter: () => {
                    screen1.classList.add('enter');
                    screen2.classList.add('enter');
                },
                onLeave: () => {
                    screen1.classList.remove('enter');
                    screen2.classList.remove('enter');
                },
                asyncTimeLine: [0.3, 3],
                asyncFromTo: [
                    [mask1, { opacity: 0 }, { opacity: 1 }, 1],
                    [screen1, { opacity: 1 }, { opacity: 0 }, 0.1],
                ],
            });

            return () => {
                if (ani) AniContainer.removeScene(ani);
            };
        }
    }, []);
    return (
        <div className={styles.comp} id="wave3-D">
            <div className="screen-1 range2" id="screen1">
                <div className="left">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744339839435/D1-1.jpg" />
                    <div className="text-wd screen-1-text">
                        <img src="https://websiteoss.ecoflow.com/upload/image/1744680775548/wd1.svg" loading="lazy" alt="" />
                        <span>{t('wd1')}</span>
                    </div>
                </div>
                <div className="right">
                    <EcoSection
                        label={t1('label')}
                        title={t1('title')}
                        desc={t1.rich('desc', {
                            sup: (v: string) => <sup>{v}</sup>,
                        })}
                    />
                    <EcoImg className="right-img" pc="https://websiteoss.ecoflow.com/upload/image/1745284818176/1.jpg" />
                </div>
                <div className="screen1-mask mask"></div>
            </div>
            <div className="screen-2">
                <div className="left">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744339903099/D2-1.jpg" />
                    <div className="text-wd screen-2-text">
                        <img src="https://websiteoss.ecoflow.com/upload/image/1744680775716/wd2.svg" loading="lazy" alt="" />
                        <span>{t('wd2')}</span>
                    </div>
                </div>
                <div className="right">
                    <EcoSection
                        label={t2('label')}
                        title={t2('title')}
                        desc={t2.rich('desc', {
                            sup: (v: string) => <sup>{v}</sup>,
                        })}
                    />
                    <EcoImg className="right-img" pc="https://websiteoss.ecoflow.com/upload/image/1744881392177/2.jpg" />
                </div>
            </div>
        </div>
    );
}
